import Question from "./Question";
import LifeCheckQuestion from "./LifeCheckQuestion";
import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { Button, CardActions, Box, Card, CardContent, Typography, Divider, Grid } from "@material-ui/core";
import { withRouter } from "react-router";
import axios from "axios";
import Cookies from "js-cookie";

import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
//import { ThreeSixty } from "@material-ui/icons";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

/**
 * アンケート形式で集計を行い診断をする
 */
class QuestionBoard extends React.Component {

  /**
   * コンストラクタ
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.state = {
      // ストレスチェック
      questions: [
        { "id": 1, "text": "なかなか眠れないことがある", "value": -1 },
        { "id": 2, "text": "ムシャクシャしたり、いらいらしたりカッとしたりする", "value": -1 },
        { "id": 3, "text": "怖くて落ち着かない", "value": -1 },
        { "id": 4, "text": "自分が悪い(悪かった)と責めてしまうことがある", "value": -1 },
        { "id": 5, "text": "頭やお腹が痛かったり、体の調子が悪かったりする", "value": -1 }
      ],
      // 生活チェック
      life_check: [
        { "id": 1, "text": "毎日、朝食を食べている", "value": -1 },
        { "id": 2, "text": "毎日、寝る時刻・起きる時刻が決まっている", "value": -1 },
        { "id": 3, "text": "自分の気持ちがリラックスする方法を知っていて、実行している", "value": -1 },
        { "id": 4, "text": "ゲームや趣味の時間にルールを決め、守っている。", "value": -1 },
        { "id": 5, "text": "身体を動かすことを意識的に行っている。", "value": -1 },
        { "id": 6, "text": "困ったことがあった時、人に助けを求める", "value": -1 },
        {
          "id": 7, "text": "ゲーム・SNS・動画などネットを使っている時間は一日当たり", "value": -1, "selector": [
            "4時間以上", "3~4時間", "1~3時間", "1時間以内", "していない"
          ]
        }
      ],
      // ストレス対処チェック
      stress_relief: [
        {
          "id": 1,
          "type": "PINK",
          "text": "現在の状況を変えるよう努力する",
          "value": -1
        },
        {
          "id": 2,
          "type": "YELLOW",
          "text": "先のことをあまり考えないようにする",
          "value": -1
        },
        {
          "id": 3,
          "type": "BLUE",
          "text": "自分で自分を励ます",
          "value": -1
        },
        {
          "id": 4,
          "type": "YELLOW",
          "text": "なるようになれと思う",
          "value": -1
        },
        {
          "id": 5,
          "type": "BLUE",
          "text": "物事の明るい面を見ようとする",
          "value": -1
        },
        {
          "id": 6,
          "type": "YELLOW",
          "text": "時が過ぎるのにまかせる",
          "value": -1
        },
        {
          "id": 7,
          "type": "PINK",
          "text": "他の人に問題解決に協力してくれるよう頼む",
          "value": -1
        },
        {
          "id": 8,
          "type": "YELLOW",
          "text": "大した問題ではないと考える",
          "value": -1
        },
        {
          "id": 9,
          "type": "PINK",
          "text": "問題の原因を見つけようとする",
          "value": -1
        },
        {
          "id": 10,
          "type": "YELLOW",
          "text": "自分が何らかの対応ができるようになるのを待つ",
          "value": -1
        },
        {
          "id": 11,
          "type": "PINK",
          "text": "自分が置かれた状況を人に聞いてもらう",
          "value": -1
        },
        {
          "id": 12,
          "type": "PINK",
          "text": "情報を集める",
          "value": -1
        },
        {
          "id": 13,
          "type": "YELLOW",
          "text": "こんなこともあると思ってあきらめる",
          "value": -1
        },
        {
          "id": 14,
          "type": "BLUE",
          "text": "今の経験は将来のためにもなると思うことにする",
          "value": -1
        }
      ]
    };
  }

  /*
   * 入力hook、本来はreduxとかでやるべき
   */
  handleValue(i, v, type) {
    if (type === "STRESS") {
      const questions = this.state.questions.slice();
      questions[i]["value"] = parseInt(v, 10);
      this.setState({ questions: questions });
    } else if (type === "LIFE") {
      const questions = this.state.life_check.slice();
      questions[i]["value"] = parseInt(v, 10);
      this.setState({ life_check: questions });
    } else if (type === "RELIEF") {
      const questions = this.state.stress_relief.slice();
      questions[i]["value"] = parseInt(v, 10);
      this.setState({ stress_relief: questions });
    }
  }

  /*
   * カウント
   */
  countValue() {
    return this.state.life_check.filter((i) => { return i.value !== -1 }).reduce((p, x) => p + x.value, 0);
  }

  /*
   * 回答チェック
   */
  isComplete(i) {
    const first = this.state.questions.filter((i) => { return i.value === -1 }).length === 0;
    const second = this.state.life_check.filter((i) => { return i.value === -1 }).length === 0;
    const third = this.state.stress_relief.filter((i) => { return i.value === -1 }).length === 0;
    if (i === "STRESS") {
      return first;
    } else if (i === "LIFE") {
      return first && second || first && this.isStabilityFirst();
    }
    return (first && second || first && this.isStabilityFirst()) && third;
  }

  /*
   * 心理安定度
   */
  isStability() {
    return this.isStabilityFirst() || this.isStabilitySecond();
  }


  /*
   *　心理安定度(life)
   */
  isStabilitySecond() {
    return this.state.life_check.filter((i) => { return i.value !== -1 }).reduce((p, x) => p + x.value, 0) >= 25;
  }

  /*
   * 心理安定度(stress)
   */
  isStabilityFirst() {
    return this.state.questions.filter((i) => { return i.value !== -1 }).reduce((p, x) => p + x.value, 0) >= 7;
  }

  /*
   * ストレス対処型を診断
   * "PINK"(問題焦点型), "YELLOW"(回避逃避型), "BLUE"(情動焦点型)のいずれかを返す。
   */
  categorize_1st() {
    const colors = { "YELLOW": 1, "BLUE": 2, "PINK": 1.2 };

    let arr = Object.keys(colors).map(e => ({
      "key": e,
      "value": this.state.stress_relief.filter(i => { return i.type === e }).reduce((p, x) => {
        return p + x.value
      }, 0) * colors[e]
    }));
    arr.sort(function (a, b) {
      if (a.value < b.value) return 1;
      if (a.value > b.value) return -1;
      return 0;
    });
    console.log(arr);
    return arr[0].key;
  }

  /*
   * 分類（2段階）
   * ストレス対処型、心理安定度
   * categorize_1st(), isStability()から結果を分類
   */
  categorize_2nd() {
    const stab = this.isStability();
    const color = this.categorize_1st();
    if (color === "PINK" && !stab) {
      return "A";
    } else if (color === "PINK" && stab) {
      return "B";
    } else if (color === "BLUE" && !stab) {
      return "C";
    } else if (color === "BLUE" && stab) {
      return "D";
    } else if (color === "YELLOW" && !stab) {
      return "E";
    } else if (color === "YELLOW" && stab) {
      return "F";
    }
  }


  /**
   * 質問表を作成
   * @param {*} i
   * @param {*} type
   */
  generate_questions(i, type) {
    if (type === "STRESS") {
      return (<Question
        value={this.state.questions[i]}
        labels={["ない", "少しある", "かなりある", "非常にある"]}
        onValueChange={(v) => {
          this.handleValue(i, v, "STRESS")
        }}></Question>)
    } else if (type === "LIFE") {
      return (<LifeCheckQuestion value={this.state.life_check[i]} onValueChange={(v) => { this.handleValue(i, v, "LIFE") }} />)
    } else if (type === "RELIEF") {
      return (<Question
        value={this.state.stress_relief[i]}
        labels={["全くしない", "たまにする", "時々する", "いつもする"]}
        onValueChange={(v) => {
          this.handleValue(i, v, "RELIEF")
        }}></Question>)
    }
  }

  /**
   *　Cardを生成
   * @param {*} title
   * @param {*} description
   * @param {*} list
   * @param {*} next
   */
  renderCard(id, title, description, list, next) {
    return (
      <Box mx="auto" p={1}>
        <Card id={id}>
          <CardContent>
            <Typography variant="h4" component="h4">
              {title}
            </Typography>
            <Typography variant="body1" component="p">
              {description}
            </Typography>
            <Divider></Divider>
            <Box p={1}></Box>
            {list}
          </CardContent>
          <CardActions>
            {next}
          </CardActions>
        </Card>
      </Box>
    )
  }

  /**
   * 次へ
   * @param {*} next
   */
  generate_next_link(next) {
    if (next === "STRESS") {
      if (!this.isComplete(next)) {
        return <Button disabled bgcolor="blue">回答してください</Button>
      } else if (this.isStabilityFirst()) {
        return <Button variant="contained" color="primary"><AnchorLink href="#3.StressReliefCheck" offset="10">次へ(3. ストレス対処チェック)</AnchorLink></Button>
      } else {
        return <Button variant="contained" color="primary"><AnchorLink href="#2.LifeCheck" offset="10">次へ(2. 生活チェック)</AnchorLink></Button>
      }
    } else if (next === "LIFE") {
      if (!this.isComplete(next)) {
        return <Button disabled>回答してください</Button>
      }
      return <Button variant="contained" color="primary"><AnchorLink href="#3.StressReliefCheck" offset="10">次へ(3. ストレス対処チェック)</AnchorLink></Button>
    } else if (next === "RELIEF") {
      if (!this.isComplete(next)) {
        return <Button disabled color="primary">回答してください</Button>
      }
      return <Button variant="contained" color="primary" onClick={() => { this.nextPage() }}>結果を見る</Button>
    }
    return (<div></div>);
  }

  generate_list() {
    return {
      "stress": this.state.questions.map(i => i.value),
      "stress_relief": this.state.stress_relief.map(i => i.value),
      "life": this.state.life_check.map(i => i.value),
      "result": this.categorize_2nd()
    }
  }

  nextPage() {
    // send spread sheet
    const tmp = this.generate_list();
    console.log(tmp);
    const apiurl = "https://script.google.com/macros/s/AKfycbyqxKce-ifBasOEK3qFjtvDwQ20A0cOdRfp9DgwYKxgfxwL08l_/exec";
    const CORS_PROXY = "https://cors-anywhere.herokuapp.com/";

    const api = axios.create({
      headers: {
        "Content-Type": "application/json"
      }
    }).post(
      CORS_PROXY + apiurl, JSON.stringify(this.generate_list())
    ).then((res) => {
      console.log("send success");
    }).catch((err) => {
      console.log(err);
    });

    // write cookie
    Cookies.set("k-mental-first", this.categorize_2nd()
      , { expires: 1 });


    this.props.history.push("/Result");

    // this.props.history.push(
    //   {
    //     pathname: "/Result",
    //     state: { result: this.categorize_2nd() }
    //   });

  }

  /**
   *
   */
  render() {
    var q_list = [];
    this.state.questions.forEach((i, index) => { q_list.push(this.generate_questions(index, "STRESS")) });
    var l_list = [];
    this.state.life_check.forEach((i, index) => {
      l_list.push(this.generate_questions(index, "LIFE"));
    });
    var s_list = [];
    this.state.stress_relief.forEach((i, index) => {
      s_list.push(this.generate_questions(index, "RELIEF"));
    })

    return (
      <ThemeProvider theme={theme}>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={11}>
            {this.renderCard("1.StressCheck", "1. ストレスチェック", "一週間に、次のことがどれくらいありましたか？", q_list, this.generate_next_link("STRESS"))}
            {this.renderCard("2.LifeCheck", "2. 生活チェック", "毎日の生活をチェックしましょう。", l_list, this.generate_next_link("LIFE"))}
            {this.renderCard("3.StressReliefCheck", "3. ストレス対処チェック", "あなたがストレスを感じている時にどのように考えたり、行動しているのかについてお聞きします。それぞれの項目を読んで、現在のあなたの考え方や行動に近いと思われる数字を選んでください。", s_list, this.generate_next_link("RELIEF"))}
          </Grid>
        </Grid >
      </ThemeProvider >
    )
  }
}

export default withRouter(QuestionBoard);

//         <h1>ストレスチェック: {this.countValue()}</h1>
        // <h2>全回答: {this.complete()}</h2>
        // <h2>安定度: {this.kibun_huantei()}</h2>
